import React from 'react'
import { ArrowShortDownIcon, ArrowShortUpIcon } from '@fourthwall/icons'
import { Icon } from '../../Icon'
import * as S from './styled'
import type { AccordionItemProps } from './types'

export const AccordionItem = ({
  heading,
  footer,
  spacing = 'regular',
  expanded = false,
  disabled,
  onChange,
  children,
}: AccordionItemProps) => {
  return (
    <S.Container $spacing={spacing} aria-expanded={expanded} data-testid="Accordion.Item">
      <S.HeadingContainer>
        <S.Heading>{heading}</S.Heading>
        {onChange && (
          <S.ExpandButton disabled={disabled} onClick={onChange}>
            <Icon component={expanded ? ArrowShortUpIcon : ArrowShortDownIcon} height={12} />
          </S.ExpandButton>
        )}
      </S.HeadingContainer>
      {expanded && children}
      {footer && footer}
    </S.Container>
  )
}
